import React from 'react'
import { Panel, Placeholder } from 'rsuite'

export default function OrganicVegetablesBGView(props) {
  const { schema } = props
  const { Paragraph } = Placeholder

  const ViewDisPlay = ({ obj }) => (
    <>
      {obj && (
        <p>
          {obj.label} {obj.value ? <b>{obj.value}</b> : <b> - </b>} {obj.postLabel || ''}
        </p>
      )}
    </>
  )
  return (
    <>
      {schema.communityBackground && (
        <Panel header={schema.communityBackground.label}>
          <div>
            <ViewDisPlay obj={schema.communityBackground.community} />
            <ViewDisPlay obj={schema.communityBackground.totalPopulation} />
            <ViewDisPlay obj={schema.communityBackground.totalHouseholds} />

            <p style={Styles.marginTop10}>
              <b>{schema.communityBackground.vegetableGrowInfo}</b>
            </p>
            <div style={Styles.marginLeft20}>
              <ViewDisPlay obj={schema.communityBackground.notGrowVegetable} />
              <ViewDisPlay obj={schema.communityBackground.useChemicals} />
              <ViewDisPlay obj={schema.communityBackground.useChemicalsBudget} />
              <ViewDisPlay obj={schema.communityBackground.notUseChemicals} />
              <ViewDisPlay obj={schema.communityBackground.growVegetableType} />
            </div>

            <p style={Styles.marginTop10}>
              <b>{schema.communityBackground.vegetableConsumption}</b>
            </p>
            <div style={Styles.marginLeft20}>
              <ViewDisPlay obj={schema.communityBackground.notBuy} />
              <ViewDisPlay obj={schema.communityBackground.buyNotSafe} />
              <ViewDisPlay obj={schema.communityBackground.buyNotSafeBudget} />
              <ViewDisPlay obj={schema.communityBackground.behaviorOther} />
            </div>

            <p style={Styles.marginTop10}>
              <b>{schema.communityBackground.editorData1.label}</b>
              {schema.communityBackground.editorData1.value ? (
                <div
                  style={Styles.marginLeft20}
                  dangerouslySetInnerHTML={{ __html: schema.communityBackground.editorData1.value }}
                />
              ) : (
                <Paragraph />
              )}
            </p>
            <p style={Styles.marginTop10}>
              <b>{schema.communityBackground.editorData2.label}</b>
              {schema.communityBackground.editorData2.value ? (
                <div
                  style={Styles.marginLeft20}
                  dangerouslySetInnerHTML={{ __html: schema.communityBackground.editorData2.value }}
                />
              ) : (
                <Paragraph />
              )}
            </p>
            <p style={Styles.marginTop10}>
              <b>{schema.communityBackground.editorData3.label}</b>
              {schema.communityBackground.editorData3.value ? (
                <div
                  style={Styles.marginLeft20}
                  dangerouslySetInnerHTML={{ __html: schema.communityBackground.editorData3.value }}
                />
              ) : (
                <Paragraph />
              )}
            </p>
          </div>
        </Panel>
      )}
    </>
  )
}

const Styles = {
  marginTop10: {
    marginTop: '10px',
  },
  marginLeft20: {
    marginLeft: '20px',
  },
}
